import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    parentescoHeredoFamiliar: [],
  },

  getters: {
    getParentescoHeredoFamiliar: (state) => state.parentescoHeredoFamiliar,
  },

  mutations: {
    SET_PARENTESCO_HEREDO_FAMILIAR(state, parentescoHeredoFamiliar) {
      state.parentescoHeredoFamiliar = parentescoHeredoFamiliar;
    },
  },

  actions: {
    async fetchParentescoHeredoFamiliar({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catparentescoHeredoFamiliar')
        .then((response) => {
          commit('SET_PARENTESCO_HEREDO_FAMILIAR', response.data.data);
        });
    },
  },
};
